import { render } from "./Skillset.vue?vue&type=template&id=74eddf87"
import script from "./Skillset.vue?vue&type=script&lang=js"
export * from "./Skillset.vue?vue&type=script&lang=js"

import "./Skillset.vue?vue&type=style&index=0&id=74eddf87&lang=css"
script.render = render

export default script